import React from "react";
import { Box, Typography } from "@mui/material";
export const NoModuleAccess = ({ message }) => {
    return (React.createElement(Box, { sx: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            textAlign: "center",
            minHeight: "60vh",
            width: "100%",
            p: 4,
        } },
        React.createElement(Typography, { variant: "h6", color: "error" }, message)));
};
